var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { devtools } from "zustand/middleware";
export var useGraphRenderingStore = create()(devtools(immer(function (set, get) { return ({
    expandedNodes: {},
    expandedSubtrees: {},
    nodeDimensions: {},
    init: function (expandedSubtrees) {
        set(function (state) {
            state.expandedNodes = {};
            state.expandedSubtrees = expandedSubtrees;
            state.nodeDimensions = {};
        });
    },
    toggleExpandedNode: function (nodeId) {
        return set(function (state) {
            state.expandedNodes[nodeId] = !get().expandedNodes[nodeId];
        });
    },
    toggleExpandedSubtree: function (nodeId) {
        return set(function (state) {
            state.expandedSubtrees[nodeId] = !get().expandedSubtrees[nodeId];
        });
    },
    updateNodeDimensions: function (entries) {
        return set(function (state) {
            var e_1, _a;
            var _b;
            try {
                for (var entries_1 = __values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
                    var e = entries_1_1.value;
                    // Figure out which node was changed
                    var target = e.target;
                    var id = (_b = target.closest(".react-flow__node")) === null || _b === void 0 ? void 0 : _b.getAttribute("data-id");
                    if (id === null || id === undefined)
                        continue;
                    // Create an entry for this node, if we don't have it, yet
                    if (!state.nodeDimensions[id]) {
                        state.nodeDimensions[id] = {};
                    }
                    // Update head/body dimensions
                    if (target.classList.contains("qg-graph-node-head")) {
                        state.nodeDimensions[id].headWidth = target.offsetWidth;
                        state.nodeDimensions[id].headHeight = target.offsetHeight;
                    }
                    else if (target.classList.contains("qg-graph-node-body")) {
                        state.nodeDimensions[id].bodyWidth = target.offsetWidth;
                        state.nodeDimensions[id].bodyHeight = target.offsetHeight;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
    },
}); })));
